module.exports = __webpack_public_path__ + "static/media/report_well_said.0fcc5f6e.svg";